#import "../../../../shared/graphql/fragments/lead-value-fragment.graphql"

mutation UpdateLeadValue($input: LeadValueUpdateInput!) {
    leadValueUpdate(input: $input) {
        lead {
            id
            ...LeadValueFragment
        }
    }
}
